import React from 'react';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  circle = false,
  className = '',
  style,
  ...props
}) => {
  const classes = [
    'animate-pulse bg-gray-200',
    circle ? 'rounded-full' : 'rounded-xl',
    className,
  ].join(' ');

  const styles: React.CSSProperties = {
    width,
    height,
    ...style,
  };

  return <div className={classes} style={styles} {...props} />;
};

export const SkeletonCard: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className = '',
}) => (
  <div className={`rounded-2xl bg-white border border-gray-100 p-4 space-y-3 ${className}`}>
    <div className="flex items-center gap-3">
      <Skeleton circle width={40} height={40} />
      <div className="flex-1 space-y-2">
        <Skeleton height={16} width="60%" />
        <Skeleton height={12} width="40%" />
      </div>
    </div>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} height={12} width={i === lines - 1 ? '70%' : '100%'} />
    ))}
  </div>
);

export default Skeleton;
